<mat-form-field class="full-width">
    <mat-label>{{label}}</mat-label>
    <input [formControl]="formCtrl" matInput [matDatepicker]="picker" 
    [placeholder]="placeHolder" title="{{placeHolder}}"
    [matTooltip]="tooltip"
    [matTooltipPosition]="tooltipPosition"
    
    [min]="minDate" [max]="maxDate"
    (dateChange)="emitChange()">
    <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
   
    <button type="button" *ngIf="formCtrl.value!==null" matSuffix  aria-label="Clear"
        [hidden]="disableClearBtn" (click)="clearControl()">
        <mat-icon>close</mat-icon>
    </button>
    <mat-error *ngIf="formCtrl.errors">{{errormessage}}</mat-error>
</mat-form-field>